
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../stores/AuthContext';

// restrictedMetadataKey: name of a Supabase app_metadata boolean flag that,
// when true for the logged-in user, hides this route (opt-out — default
// visible). Admin-set per user in the Supabase dashboard (same pattern as
// app_metadata.erp_sidecar_url in backend/src/shared/auth.py). Absent/false =
// unrestricted (default for everyone), so this never changes behavior unless
// a flag is explicitly set. This check applies even to admins.
//
// requireMetadataKey: name of a Supabase app_metadata boolean flag that
// must be true (or the user must be an admin) for this route to be
// visible (opt-in — default hidden). Added 2026-08-26 for /admin/tenants
// and to flip /projects from opt-out to opt-in — see
// docs/MULTI_TENANT_ARCHITECTURE.md Phase 2.
//
// adminOnly: route is visible only to users with app_metadata.role === 'admin'.
const ProtectedRoute = ({ children, restrictedMetadataKey, requireMetadataKey, adminOnly }) => {
    const { user, loading } = useAuth();

    if (loading) {
        return <div className="h-screen w-screen flex items-center justify-center">Loading...</div>; // Or a spinner
    }

    if (!user) {
        return <Navigate to="/login" replace />;
    }

    if (restrictedMetadataKey && user.app_metadata?.[restrictedMetadataKey]) {
        return <Navigate to="/" replace />;
    }

    const isAdmin = user.app_metadata?.role === 'admin';

    if (adminOnly && !isAdmin) {
        return <Navigate to="/" replace />;
    }

    if (requireMetadataKey && !isAdmin && user.app_metadata?.[requireMetadataKey] !== true) {
        return <Navigate to="/" replace />;
    }

    return children;
};

export default ProtectedRoute;
